import {Component, inject, OnInit, signal} from '@angular/core'
import {IFlatItem, List} from '../../../1-components/10-customers/list/list'
import {WaitComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {DataService} from '../../../services/data-service'
import {MatDialog} from '@angular/material/dialog'
import {Filter} from '../../../1-components/10-customers/filter/filter'
import {MatMiniFabButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {GUIDE_PATH, HOME_PATH} from '../../../0-application/shared'
import {RouterLink} from '@angular/router'
import {MatTooltip} from '@angular/material/tooltip'

@Component({
  selector: 'spb-start',
  imports: [
    List,
    Filter,
    MatMiniFabButton,
    MatIcon,
    RouterLink,
    MatTooltip
  ],
  templateUrl: './start.html',
  styleUrl: './start.scss'
})
export class Start implements OnInit {

  public filtered = signal<IFlatItem[]>([])

  public readonly service = inject(DataService)

  protected readonly HOME_PATH = HOME_PATH
  protected readonly GUIDE_PATH = GUIDE_PATH

  private readonly dialog = inject(MatDialog)

  public ngOnInit(): void {
    const ref = this.dialog.open(WaitComponent, {
      data: {
        title: 'Uppdaterar listan',
        text: '....'
      }
    })
    this.service.list(true).subscribe(() => {
      ref.close()
    })
  }
}
